<template>
	<div class="volunteer-home-intro-content">
    <div class="article__html" v-html="curData_.txt"></div>
	</div>
</template>

<script>
	import listMixin from '@/mixins/list.js'
	export default {
		mixins: [ listMixin ],
		data() {
			return {
				typeList: [{
					value: 'dxwhggk',
					label: '概况'
				}]
			}
		}
	}
</script>

<style lang="scss" scoped="scoped">
	.volunteer-home-intro-content{
		background-color: #fff;
	}
</style>
